const env = {
  awsRegion: 'ap-southeast-2',
  userPoolId: 'ap-southeast-2_Kvz7mvIAK',
  userPoolWebClientId: 's21n0lq1hj52mejeipj0q4a5p',
  cognitoDomain: 'dnrmereports-dev.auth.ap-southeast-2.amazoncognito.com',
  cognitoRedirectUrl: 'https://dnrmereports.build.ig.orgn.io/',
  apiEndpoint: 'https://dnrmereportsapi.build.ig.orgn.io',
  spUrl:
    'https://origin.sharepoint.com/sites/datawarehousevisualisationsquad/Shared%20Documents/Forms/AllItems.aspx?csf=1&web=1&e=USpcPg&cid=a7fd4d53%2D454b%2D40fa%2Dbe21%2D9de35112bf4a&FolderCTID=0x0120000CE3CEBF04DD2A4293B3D6348CBC53D0&viewid=e23c8552%2Dbb6d%2D49a0%2Db82c%2D512c883bfa52&id=%2Fsites%2Fdatawarehousevisualisationsquad%2FShared%20Documents%2FDNRME%5FFiles',
};
export default env;
